import {
    createManualJournalEntriesBodySchema,
    createManualJournalEntryBodySchema,
    deleteManualJournalEntryBodySchema,
    getManualJournalEntriesQuerySchema,
    getManualJournalEntriesResponseSchema,
    JournalEntrySchema,
    ManualJournalEntriesMutationResponseSchema,
    ManualJournalMutationResponseSchema,
    updateManualJournalEntryBodySchema,
} from "@common/schemas/domains/accounting/journalEntry";
import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ErrorMessageSchema } from "@common/schemas/error.schema";

const c = initContract();

export const journalEntryContract = c.router(
    {
        getJournalEntry: {
            method: "GET",
            path: "/:entityId/:id",
            pathParams: z.object({
                entityId: z.coerce.number(),
                id: z.string().uuid(),
            }),
            query: z.object({
                ledgerBasis: z.nativeEnum(AccountingLedgerBasis),
                ledgerId: z.string().uuid().optional(),
            }),
            responses: {
                200: JournalEntrySchema,
                404: c.noBody(),
            },
        },
        getManualJournalEntries: {
            method: "GET",
            path: "/manual/:entityId",
            pathParams: z.object({
                entityId: z.coerce.number(),
            }),
            query: getManualJournalEntriesQuerySchema,
            responses: {
                200: getManualJournalEntriesResponseSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        createManualJournalEntry: {
            method: "POST",
            path: "/manual/:entityId",
            pathParams: z.object({
                entityId: z.coerce.number(),
            }),
            body: createManualJournalEntryBodySchema,
            responses: {
                201: ManualJournalMutationResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        createManualJournalEntries: {
            method: "POST",
            path: "/manual/:entityId/bulk",
            pathParams: z.object({
                entityId: z.coerce.number(),
            }),
            body: createManualJournalEntriesBodySchema,
            responses: {
                201: ManualJournalEntriesMutationResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        updateManualJournalEntry: {
            method: "PUT",
            path: "/manual/:entityId/:journalEntryId",
            pathParams: z.object({
                entityId: z.coerce.number(),
                journalEntryId: z.string().uuid(),
            }),
            body: updateManualJournalEntryBodySchema,
            responses: {
                200: ManualJournalMutationResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        deleteManualJournalEntry: {
            method: "DELETE",
            path: "/manual/:entityId/:journalEntryId",
            pathParams: z.object({
                entityId: z.coerce.number(),
                journalEntryId: z.string().uuid(),
            }),
            body: deleteManualJournalEntryBodySchema,
            responses: {
                200: c.noBody(),
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/accounting/journal-entries",
    },
);
